import { render } from "./IconGroupOfHumans.vue?vue&type=template&id=71d7ae94"
import script from "./IconGroupOfHumans.vue?vue&type=script&lang=js"
export * from "./IconGroupOfHumans.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__